import { useEffect } from 'react';
import useUIStore from '@/store/useUIStore';
import useAuthStore from '@/store/useAuthStore';

const ThemeInitializer: React.FC = () => {
  const { backgroundColor } = useUIStore();
  const { user } = useAuthStore();

  useEffect(() => {
    // Initialize accent colors on mount
    const hexToRgb = (hex: string): { r: number; g: number; b: number } | null => {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    };

    const updateAccentColors = (hexColor: string) => {
      const rgb = hexToRgb(hexColor);
      if (rgb) {
        document.documentElement.style.setProperty('--accent-1', `${rgb.r}, ${rgb.g}, ${rgb.b}`);
        document.documentElement.style.setProperty('--accent-2', `${Math.max(0, rgb.r - 20)}, ${Math.max(0, rgb.g - 20)}, ${Math.max(0, rgb.b - 20)}`);
      }
    };

    updateAccentColors(backgroundColor);
  }, [backgroundColor]);

  useEffect(() => {
    if (user) {
      useUIStore.getState().loadTheme();
    }
  }, [user]);

  return null; // This component doesn't render anything
};

export default ThemeInitializer;
